import React from "react";
import { HEADER_HEIGHT } from ".";

export default function HeaderSpacer({ className = "" }) {
  return <div className={`${HEADER_HEIGHT} ${className}`} />;
}
